import { FC } from 'react'
import { Backdrop, CircularProgress, Stack, Typography } from '@mui/material'

import { useSlowLoadingMessage } from '@/common/hooks'

const LoadingOverlay: FC = () => {
  const message = useSlowLoadingMessage()

  return (
    // This ensures that the backdrop only appears on the component on which it is used
    <Backdrop open sx={{ position: 'absolute' }}>
      <Stack justifyContent="center" alignItems="center" sx={{ p: 3 }}>
        <CircularProgress />
        {message && (
          <Typography
            variant="body2"
            align="center"
            sx={{ color: '#FFF', textShadow: '#FFF 1px 0 10px', whiteSpace: 'pre-line' }}
          >
            {message}
          </Typography>
        )}
      </Stack>
    </Backdrop>
  )
}

export default LoadingOverlay
